import { Component, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import {
  VipDiscountDto,
  OriginalPricingResponse,
  OriginalSortimentEntryResponse,
} from '@app/api/models';
import { cancellationMockDateHu } from '@shared/constants/cancellation-mock-date';
import { calculateDiscount } from '@shared/helpers/calculate-discount.helper';

@Component({
  selector: 'app-vip-discounts-original-prices-modal',
  templateUrl: './vip-discounts-original-prices-modal.component.html',
  styleUrls: ['./vip-discounts-original-prices-modal.component.scss'],
})
export class VipDiscountsOriginalPricesModalComponent {
  discountColumns = ['discount', 'startDate', 'endDate'];
  priceColumns!: Array<any>;
  displayedColumns!: Array<any>;

  sortedColumns = [
    'MANUFACTURER_OR_IMPORTER',
    'WHOLESALE',
    'RETAIL',
    'CONSUMER',
  ];

  columnTitles: { [key: string]: string } = {
    siteName: 'PRICING.PRODUCT_PRICING_TABLE_HEADER.SITE_NAME',
    discount: 'VIP_DISCOUNTS.SETTINGS.DISCOUNT',
    startDate: 'VIP_DISCOUNTS.SETTINGS.DATE_FROM',
    endDate: 'VIP_DISCOUNTS.SETTINGS.DATE_TO',
    MANUFACTURER_OR_IMPORTER:
      'PRICING.PRODUCT_PRICING_TABLE_HEADER.MANUFACTURER_OR_IMPORTER',
    WHOLESALE: 'PRICING.PRODUCT_PRICING_TABLE_HEADER.WHOLESALER',
    RETAIL: 'PRICING.PRODUCT_PRICING_TABLE_HEADER.RETAILER',
    CONSUMER: 'PRICING.PRODUCT_PRICING_TABLE_HEADER.END_CONSUMER',
  };

  dataSource: Array<OriginalSortimentEntryResponse & VipDiscountDto> = [];

  calculateDiscount = calculateDiscount;
  cancellationMockDateHu = cancellationMockDateHu;

  constructor(
    public dialogRef: MatDialogRef<VipDiscountsOriginalPricesModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      product: OriginalPricingResponse;
      discount: VipDiscountDto;
    }
  ) {
    this.priceColumns =
      data.product.originalSortimentEntries
        ?.flatMap((entry) => entry.prices?.map((price) => price.segment))
        .filter((item, idx, array) => array.indexOf(item) === idx)
        .sort((a, b) => {
          return this.sortedColumns.indexOf(a ?? '') <
            this.sortedColumns.indexOf(b ?? '')
            ? -1
            : 1;
        }) ?? [];
    this.displayedColumns = [
      'siteName',
      ...this.discountColumns,
      ...this.priceColumns,
    ];
    this.dataSource =
      data.product.originalSortimentEntries?.map((item) => ({
        ...item,
        ...data.discount,
      })) ?? [];
  }
}
